import {
  JOBS_RECRUIT_FETCHING,
  JOBS_RECRUIT_FAILED,
  JOBS_RECRUIT_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case JOBS_RECRUIT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case JOBS_RECRUIT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case JOBS_RECRUIT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
